import { z } from "zod";

export const schema = z
	.object({
		id_post: z.number({ required_error: "ID_POST é obrigatório" }).int(),
		id_instagram: z
			.number({
				required_error: "ID_INSTAGRAM é obrigatório",
				invalid_type_error: "ID_INSTAGRAM é obrigatório",
			})
			.int()
			.gt(0, "Selecione a conta do instagram"),

		all_posts: z.boolean().optional(), // campo temporário para indicar se deve buscar todos os posts (true) ou só os recentes (false). Não é salvo no banco.
		cod_post: z.string().nullable().optional(),
		mensagem_dm: z.string().min(1, "Mensagem do DM é obrigatório").max(1000, "Máximo 1000 caracteres").optional(),
		mensagem_comentario_1: z
			.string()
			.min(1, "Mensagem do comentário é obrigatório")
			.max(1000, "Máximo 1000 caracteres")
			.optional(),
		// mensagem_dm_2: z.string().max(1000, "Máximo 1000 caracteres").optional(),
		mensagem_comentario_2: z.string().max(1000, "Máximo 1000 caracteres").optional(),
		mensagem_comentario_3: z.string().max(1000, "Máximo 1000 caracteres").optional(),

		// aceita "" ou URL válida
		url_imagem: z.string().url("URL da imagem inválida").or(z.literal("")).optional(),
		ativo: z.boolean({ required_error: "ATIVO é obrigatório" }),

		link_mensagem_dm: z.string().url("Link inválido").or(z.literal("")).or(z.null()).optional(),
		titulo_link: z.string().max(100, "Máximo 100").or(z.literal("")).or(z.null()).optional(),

		// multiselect
		triggers: z.array(z.string().min(1)).nonempty("Selecione ou adicione pelo menos um canal"),
	})
	.refine(
		(data) =>
			!(data.link_mensagem_dm && data.link_mensagem_dm.trim().length > 0) ||
			(data.titulo_link && data.titulo_link.trim().length > 0),
		{
			message: "Preencha o título se informar o link.",
			path: ["titulo_link"],
		}
	)
	.refine(
		(data) =>
			!(data.titulo_link && data.titulo_link.trim().length > 0) ||
			(data.link_mensagem_dm && data.link_mensagem_dm.trim().length > 0),
		{
			message: "Preencha o link se informar o título.",
			path: ["link_mensagem_dm"],
		}
	)
	.superRefine((data, ctx) => {
		// Regra para cod_post x all_posts
		if (!data.all_posts) {
			if (!data.cod_post || data.cod_post.trim().length === 0) {
				ctx.addIssue({
					path: ["cod_post"],
					message: "Escolha um post do Instagram",
					code: z.ZodIssueCode.custom,
				});
			}
		}
	});
export const schemaDefaultValues = {
	id_post: 0,
	id_instagram: 0,
	cod_post: "",
	mensagem_dm: "",
	mensagem_dm_2: "",
	ativo: true,
	all_posts: false,
	mensagem_comentario_1: "",
	mensagem_comentario_2: "",
	mensagem_comentario_3: "",
	url_imagem: "", // "" é aceito
	link_mensagem_dm: "", // "" é aceito
	titulo_link: "", // "" é aceito
	triggers: [],
};
